import Alert from '../Alert';
import React from 'react';

/*
  Alerts users about service breaks.
 */
export const ServiceAlert = () => {
  return (
    <Alert type="error">
      <p>
        Kesä–, heinä- ja elokuussa osalla hoitoyksiköistä on poikkeavia aukioloaikoja, tai yksiköt voivat olla
        tilapäisesti suljettu. Tämän vuoksi hoitokeskusteluviesteihin vastaaminen voi kestää normaalia
        pidempään kuin kaksi arkipäivää. Viesteihin vastataan hoitoyksiköiden aukioloaikoina. Ajantasaiset
        aukioloajat löydät Pirkanmaan hyvinvointialueen verkkosivuilta.
        <br />
        <br />
        Jos asiasi on kiireellinen, ole yhteydessä päivystykseen tai päivystysapuun p. 116117.
      </p>
    </Alert>
  );
};
